// removed by extract-text-webpack-plugin
module.exports = {"Menu":"style__Menu___12vxd","Additional":"style__Additional___JQRdN","Title":"style__Title___1RmaY","Checkboxes":"style__Checkboxes___uRnt1","Checkbox":"style__Checkbox___1X8-h","Button":"style__Button___2mYdz","Header":"style__Header___2vbO-","Count":"style__Count___xiH_N","Icon":"style__Icon___2Oqxx","Active":"style__Active___3PxDk","FirstColumn":"style__FirstColumn___EWqkt","SecondColumn":"style__SecondColumn___2f7aU","ThirdColumn":"style__ThirdColumn___3iw5s","ButtonWrap":"style__ButtonWrap___2-fhw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/FiltersBar/Filters/Advantages/style.scss
// module id = 1393
// module chunks = 0